import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

export function formatTime(unixTime: number): string {
  return format(unixTime * 1000, 'HH:mm:ss')
}

export function formatDatetime(unixTime: number): string {
  return format(unixTime * 1000, 'yyyy.MM.dd HH:mm:ss')
}

export function formatDateInTimezone(
  date: string | Date,
  dateFormat: string,
): string {
  return formatInTimeZone(
    date,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    dateFormat,
  )
}

export function getRandomDateTimeInYear(year: number): string {
  const start = new Date(year, 0, 1)
  const end = new Date(year, 11, 31, 23, 59, 59, 999)
  const randomTime =
    start.getTime() + Math.random() * (end.getTime() - start.getTime())

  return format(new Date(randomTime), 'yyyy-MM-dd HH:mm:ss')
}
